import React from 'react'
import "../index.css"

import { Button, Table } from '../../../../helpers'
import { Dialog } from 'primereact/dialog'


const UnupdatedGSTINs = (props) => {

    const { visibleUnupdatedGSTINs, unupdatedGSTINs } = props

    const tradeNameBody = (row) => {
        if(row.gstinTradeName){
            return row.gstinTradeName
        }

        return "N/A"
    }

    const tableColumns = [
        {
            header: 'GSTIN Code',
            field: 'gstinCode',
        },
        {
            header: 'Trade Name',
            body: tradeNameBody,
        }
    ]

    return (
        <div>
            <Dialog visible={visibleUnupdatedGSTINs} onHide={() => props.setVisibleUnupdatedGSTINs(false)} header="Unupdated GSTINs" style={{ width: '60vw' }}>
                <div className="followup-table" style={{ order: "1", width: "100%" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                tableColumns={tableColumns}
                                data={unupdatedGSTINs}
                                scrollable={"true"}
                                scrollHeight="450px"
                                loading={false}
                            />
                        </div>
                    </div>
                </div>
                <div className='flex justify-content-end mt-2'>
                    <Button label="Close" className="small-btn" onClick={() => props.setVisibleUnupdatedGSTINs(false)} />
                </div>
            </Dialog>
        </div>
    )
}

export default UnupdatedGSTINs